import { useAgentConversation } from '../hooks/useAgentConversation';
import AgentChat from '../components/AgentChat';
import AgentFormPreview from '../components/AgentFormPreview';
import { PageTitle } from '../../../../../_metronic/layout/core';

export default function AgentPage() {
	const { state, selectedTemplate, progress, handleUserInput, exportJSON, restart } =
		useAgentConversation();

	const handleFieldChange = (key: string, value: string | string[]) => {
		state.formValues[key] = value;
	};

	return (
		<div className="flex h-screen flex-col overflow-hidden bg-gray-50 max-h-[calc(100vh-150px)]">
			<PageTitle>Briefing de Promoções - Agente Virtual</PageTitle>
			<div className="mx-auto flex w-full flex-1 flex-col">
				<div className="grid flex-1 grid-cols-1 gap-6 md:grid-cols-[420px_1fr]">
					<AgentChat
						state={state}
						progress={progress}
						onUserInput={handleUserInput}
						onExport={exportJSON}
						onRestart={restart}
					/>

					<AgentFormPreview
						template={selectedTemplate}
						values={state.formValues}
						onFieldChange={handleFieldChange}
					/>
				</div>
			</div>
		</div>
	);
}